﻿/*
 * For decimal cell
 */
import { Component, ViewContainerRef, ViewChild, AfterViewInit } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
@Component({
    selector: 'numeric-cell',
    template: `<input #input numericInput [(ngModel)]="value">`
})
export class NumericEditorComponent implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: number;
    private cancelBeforeStart: boolean = false;

    @ViewChild('input', { read: ViewContainerRef }) public input;

    agInit(params: any): void {
        this.params = params;
        this.value = this.params.value;
        this.input.element.nativeElement.className = "ag-input-text-wrapper ag-cell-edit-input text-right";
        // only start edit if key pressed is a number, not a letter
        this.cancelBeforeStart = false;
    }
    getValue(): any {
        return this.value;
    }
    isCancelBeforeStart(): boolean {
        return this.cancelBeforeStart;
    }
    isCancelAfterEnd(): boolean { // will reject the number if spicfy the condition
        //return this.value > 1000000;
        return false;
    };
    ngAfterViewInit() {// dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
       // this.input.element.nativeElement.focus();
    }
    focusIn(): void {
        this.input.element.nativeElement.focus();
    }
}
